import Vue from "vue";
import Vuex from "vuex";
//import createPersistedState from 'vuex-persistedstate'
import { mortgageLeanModule } from "./modules/mortgageLean";
import { mortgageDataModule } from "./modules/mortgageData";
import { affordDataModule } from "./modules/affordData";
import { mortgageAffordModule } from "./modules/mortgageAfford";
import { uiModule } from "./modules/ui";
import { locationsModule } from "./modules/locations";
import { personalDataModule } from "./modules/personalData";

Vue.use(Vuex);

export const Store = new Vuex.Store({
  modules: {
    mortgageLean: mortgageLeanModule,
    mortgageData: mortgageDataModule,
    personalData: personalDataModule,
    affordData: affordDataModule,
    mortgageAfford: mortgageAffordModule,
    locations: locationsModule,
    ui: uiModule,
  },
  //plugins: [createPersistedState()]
});
